import React, { ReactElement } from 'react';
import { routes } from '../services/routers/router';
import { AppBar } from './components/AppBar/AppBar';
import { Footer } from './components/Footer/Footer';
import { AuthProvider } from '../features/auth/AuthProvider';
import { RegisterModal } from '../features/register/components/RegisterModal';

import './App.scss';
import { Login } from '../features/login/Login';

export const App = (): ReactElement => {
  return (
    <AuthProvider>
      <AppBar />
      <main className="main-container">{routes}</main>
      <Footer />
      <Login />
      <RegisterModal />
    </AuthProvider>
  );
};
